export const envTypes: Readonly<any> = {
    Dev: 2,
    PreRun: 8,
    Release_Source: 4,
    QA: 3,
    UAT: 6,
    Pre_Prod: 7,
    Prod: 5
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/constants/envTypes.ts